// hooks/useContactOrganizer.js

import { useState } from 'react';
import axiosClient from '../api/axiosClient';
import { toast } from 'react-toastify';

/**
 * Hook para manejar el contacto con organizadores de eventos.
 * @param {string} eventId - ID del evento.
 * @returns {object} { contactOrganizer, loading, error }
 */
const useContactOrganizer = (eventId) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const contactOrganizer = async (contactData) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axiosClient.post(`/api/events/${eventId}/contact-organizer`, contactData);

      if (response.data.success) {
        toast.success(response.data.message || 'Mensaje enviado exitosamente.');
        return { success: true, data: response.data };
      } else {
        const errorMessage = response.data.message || 'Error al enviar el mensaje.';
        setError(errorMessage);
        toast.error(errorMessage);
        return { success: false, error: errorMessage };
      }
    } catch (err) {
      console.error('Error al contactar organizador:', err);
      const errorMessage = err.response?.data?.message || 'Error al enviar el mensaje.';
      setError(errorMessage);
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return { contactOrganizer, loading, error };
};

export default useContactOrganizer;